import { PatientInfoButton } from '@/app/_components/layouts/headerMenu/patientInfoButton';
import { useIsWelfare } from '@/app/_hooks/useIsWelfare';
import { usePatient } from '@/app/_hooks/usePatient';
import { CLIENT_ENV } from '@/config/configuration';
import { trackClickHeaderAccediRegistrati } from '@/utils/trackingGtm';
import { ELButton } from '@davincihealthcare/elty-design-system-react';
import { UserIcon } from '@heroicons/react/24/outline';

type Props = {
  size?: 'small' | 'medium';
  isHiddenIfPatientExists?: boolean;
};

export const WebappCTAMenu: React.FC<Props> = ({ size = 'small', isHiddenIfPatientExists = false }) => {
  const isWelfare = useIsWelfare();
  const { patient } = usePatient();

  const { NEXT_PUBLIC_WEBAPP_PATIENT_URL } = CLIENT_ENV();

  const onButtonClick = () => {
    trackClickHeaderAccediRegistrati();
    window.location.href = NEXT_PUBLIC_WEBAPP_PATIENT_URL;
  };

  if (isWelfare || (patient && isHiddenIfPatientExists)) return null;

  if (patient) {
    return <PatientInfoButton patient={patient} size={size} />;
  }

  return (
    <ELButton
      label="Accedi o registrati"
      aria-label="Accedi o registrati"
      variant="outlined"
      color="primary"
      onClick={onButtonClick}
      leadingIcon={<UserIcon />}
      size={size}
    />
  );
};
